module.exports = __webpack_public_path__ + "static/media/grave.cc63ba36.jpg";